import { API, authClient } from "../index";

// Get tip by id
export const getTipById = (id) => {
  return authClient().get(`${API}/tip/${id}`);
};
export const getTips = () => {
  return authClient().get(`${API}/tip`);
};

// Create tip
export const postTip = async (tip) => {
  return authClient().post(`${API}/tip`, tip);
};

// Update tip
export const updateTip = async (id, tip) => {
  return authClient().put(`${API}/tip/${id}`, tip);
};
